import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { films } from "@/mocks/films";
import { specials } from "@/mocks/specials";
import useDocumentMeta from "@/hooks/useDocumentMeta";

const team = [
  {
    name: "沈知源",
    role: "内容主编",
    desc: "负责作品条目整理与剧情简介撰写，偏爱悬疑与家庭题材。",
    photo:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20calm%20East%20Asian%20woman%20in%20her%20thirties%20wearing%20a%20dark%20navy%20knit%20sweater%2C%20neutral%20warm%20grey%20backdrop%2C%20soft%20window%20lighting%2C%20subtle%20film%20grain%2C%20editorial%20photography%20style%2C%20no%20text%2C%20squarish%20composition&width=500&height=500&seq=team-shen-zhiyuan&orientation=squarish",
  },
  {
    name: "安向宇",
    role: "资料整理",
    desc: "负责年份、时长、演职员等基础信息校对，追求条目一致。",
    photo:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20quiet%20East%20Asian%20man%20in%20his%20thirties%20with%20short%20black%20hair%20and%20round%20glasses%2C%20charcoal%20shirt%2C%20neutral%20warm%20beige%20backdrop%2C%20soft%20directional%20lighting%2C%20subtle%20film%20grain%2C%20editorial%20photography%2C%20no%20text%2C%20squarish%20composition&width=500&height=500&seq=team-an-xiangyu&orientation=squarish",
  },
  {
    name: "柳河",
    role: "专题策划",
    desc: "负责专题片单与剧情资讯选题，喜欢把作品放在一起看。",
    photo:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20friendly%20East%20Asian%20person%20in%20their%20late%20twenties%20with%20tousled%20dark%20hair%2C%20cream%20colored%20oversized%20jacket%2C%20muted%20terracotta%20backdrop%2C%20soft%20natural%20lighting%2C%20subtle%20analog%20grain%2C%20editorial%20photography%2C%20no%20text%2C%20squarish%20composition&width=500&height=500&seq=team-liu-he&orientation=squarish",
  },
];

export default function About() {
  useDocumentMeta({
    title: "关于我们 - 韩国AV影视资料站",
    description:
      "了解韩国AV影视资料站的定位、内容范围与版权声明。我们专注整理韩国影视作品资料与剧情介绍，不提供播放与下载服务。",
    keywords: "关于韩国AV,影视资料站,网站介绍,版权声明,韩国影视资讯",
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />

      <main className="flex-1">
        <section className="w-full bg-primary-950">
          <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16 lg:px-8">
            <span className="text-[11px] font-medium uppercase tracking-[0.2em] text-accent-400">About Us</span>
            <h1 className="mt-3 max-w-3xl font-heading text-[30px] font-semibold leading-tight text-background-50 md:text-[38px]">
              关于韩国AV：一个把影视资料整理清楚的资料站
            </h1>
            <p className="mt-4 max-w-2xl text-[13px] leading-8 text-primary-200 md:text-[14px]">
              我们相信，找到一部想看作品的前提，是先看清楚它讲了一个什么故事。因此这里没有抢眼的播放按钮，只有尽量完整、准确、可供检索的作品资料。
            </p>
          </div>
        </section>

        <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14 lg:px-8">
          <section className="grid grid-cols-1 gap-8 lg:grid-cols-[1.25fr_1fr]">
            <div>
              <h2 className="flex items-center gap-2 font-heading text-[22px] font-semibold text-foreground-950">
                <span className="h-5 w-1 rounded-full bg-accent-500" />
                网站定位
              </h2>
              <div className="mt-4 space-y-4 text-[13px] leading-8 text-foreground-700">
                <p>
                  韩国AV 是一个面向韩国影视爱好者的资料型站点。我们把分散的影视作品信息按题材、年份与评分重新组织，帮助用户在较短时间内判断一部作品是否值得看。核心内容包括作品基本信息、剧情简介、详细介绍与题材标签。
                </p>
                <p>
                  站点不做资源聚合，也不提供任何影片文件。所有涉及「资源」的位置均以索引样式呈现，并明确标注为演示状态，仅用于说明界面形态。我们更希望用户把时间花在读剧情、选作品上。
                </p>
                <p>
                  内容结构遵循三条原则：条目之间信息口径一致；每个作品只保留一个独立详情地址；所有分类与推荐都能互相跳转，避免出现找不到出路的页面。
                </p>
              </div>
              <div className="mt-6 flex flex-wrap gap-2">
                {["资料整理", "剧情介绍", "专题片单", "不提供播放", "持续更新"].map((tag) => (
                  <span
                    key={tag}
                    className="rounded-md border border-background-300 bg-background-100 px-3 py-1.5 text-[11px] text-foreground-600"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              {[
                { value: String(films.length), label: "影视作品条目", icon: "ri-film-line" },
                { value: String(specials.length), label: "主题专题合集", icon: "ri-bookmark-3-line" },
                { value: "9", label: "题材分类维度", icon: "ri-price-tag-3-line" },
                { value: "每周", label: "资料更新频率", icon: "ri-refresh-line" },
              ].map((item) => (
                <div key={item.label} className="rounded-lg border border-background-200/90 bg-background-50 p-4">
                  <span className="flex h-8 w-8 items-center justify-center rounded bg-primary-50 text-primary-600">
                    <i className={`${item.icon} text-sm`} />
                  </span>
                  <p className="mt-3 font-heading text-[24px] font-semibold leading-none text-foreground-950">{item.value}</p>
                  <p className="mt-1.5 text-[11px] text-foreground-500">{item.label}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-2">
            <div className="rounded-lg border border-background-200/90 bg-background-100 p-5 md:p-6">
              <h3 className="flex items-center gap-2 text-[15px] font-semibold text-foreground-950">
                <i className="ri-shield-check-line text-primary-600" />
                版权声明
              </h3>
              <ul className="mt-3 space-y-2.5 text-[12px] leading-7 text-foreground-600">
                <li>本站作品名称、年份、时长等基础信息仅用于资料展示与检索。</li>
                <li>剧情简介、详细介绍与专题文案均为本站整理撰写，转载请注明来源。</li>
                <li>所有图片均为示意素材，不代表实际影视画面或演职员肖像。</li>
                <li>如相关权利方认为内容存在不当之处，可通过联系页提出，我们会及时调整。</li>
              </ul>
            </div>
            <div className="rounded-lg border border-background-200/90 bg-background-50 p-5 md:p-6">
              <h3 className="flex items-center gap-2 text-[15px] font-semibold text-foreground-950">
                <i className="ri-service-line text-accent-600" />
                服务范围
              </h3>
              <ul className="mt-3 space-y-2.5 text-[12px] leading-7 text-foreground-600">
                <li>提供影视作品资料浏览、题材分类、关键词搜索与专题片单。</li>
                <li>提供剧情介绍与相关内容解析，帮助判断作品是否适合观看。</li>
                <li>不提供在线播放、下载、资源存储或任何付费观影服务。</li>
                <li>页面中的资源索引按钮均为演示交互，不具备真实跳转能力。</li>
              </ul>
            </div>
          </section>

          <section className="mt-12">
            <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
              <div>
                <span className="text-[11px] font-medium uppercase tracking-[0.18em] text-accent-700">Our Team</span>
                <h2 className="mt-1.5 font-heading text-[22px] font-semibold text-foreground-950">团队成员</h2>
                <p className="mt-1.5 text-[12px] text-foreground-500">以下为站点演示内容，人名与简介均为虚构。</p>
              </div>
            </div>

            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {team.map((member) => (
                <article key={member.name} className="overflow-hidden rounded-lg border border-background-200/90 bg-background-50">
                  <div className="aspect-[4/3] w-full overflow-hidden bg-background-200">
                    <img
                      src={member.photo}
                      alt={`${member.name} 团队成员头像`}
                      title={`${member.name} 韩国AV资料站团队成员`}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                  <div className="p-4">
                    <div className="flex items-center justify-between">
                      <h3 className="text-[14px] font-semibold text-foreground-950">{member.name}</h3>
                      <span className="rounded bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-800">{member.role}</span>
                    </div>
                    <p className="mt-2 text-[12px] leading-6 text-foreground-600">{member.desc}</p>
                  </div>
                </article>
              ))}
            </div>
          </section>

          <section className="mt-12 flex flex-col items-start justify-between gap-5 rounded-lg bg-primary-950 p-6 md:flex-row md:items-center md:p-8">
            <div>
              <h2 className="font-heading text-[20px] font-semibold text-background-50">发现资料有误，或想补充作品？</h2>
              <p className="mt-1.5 max-w-xl text-[12px] leading-6 text-primary-200">
                我们欢迎影迷一起完善条目。提交时说明作品名称与需要修改的字段即可。
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/contact"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-[13px] font-medium text-primary-950 transition-colors hover:bg-accent-400"
              >
                填写反馈表单
                <i className="ri-arrow-right-line text-sm" />
              </Link>
              <Link
                to="/category"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-700 px-4 py-2.5 text-[13px] text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                浏览作品
              </Link>
            </div>
          </section>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}